<template>
    <div>
        <Modal class="remotelinkoper-modal"
               width="600"
               v-model="modal"
               @on-cancel="cancel"
               :mask-closable="false">
            <div class="title-container">
                <span>{{$t(data.operType)}}</span>
                <span v-if="data.operType && data.operType.indexOf('Remote') > -1 && envConsoleType === 'VMware'">
                    <Poptip trigger="hover"
                            placement="right">
                        <i class="icon-prompt-1-o"></i>
                        <div slot="content">
                            <!-- TODO 使用Vmware Remote Console -->
                            {{$t('访问时，客户端将具有实例的所有管理权限，请与平台用户权限配合进行使用控制')}}
                        </div>
                    </Poptip>
                </span>
            </div>
            <div class="content-container">
                <p style="margin-bottom: 20px;color: orange;padding-right: 30px;"
                   v-if="data.operType && data.operType.indexOf('Remote') > -1 && envConsoleType === 'VMware'">
                    <i style="color: orange;margin-right: 5px;"
                       class="icon-prompt-1-o"></i>
                    {{$t('请先安装VMware Remote Console（VMRC）软件，以连接到客户端设备和访问高级键盘功能。')}}
                    <!-- 若还未安装，点击<a @click="download()">下载Remote Console</a> -->
                </p>
                <div class="os-top-container">
                    <img :src="osIcon[(data.osCategory ||'noneos').toLowerCase()]">
                    <p>{{$t(data.instanceName)}}</p>
                </div>
                <Form ref="form"
                      :label-width="84"
                      :model="formData"
                      :rules="rules"
                      label-position="left"
                      v-show="isShowForm"
                      class="form">
                    <!--资源ID -->
                    <div class="label-width"
                         v-if="formMap['instanceId'].indexOf(envConsoleType) > -1">
                        <span>{{$t('资源ID')}}：</span>
                        <span>{{data.instanceId}}</span>
                    </div>
                    <!--分区/数据中心 -->
                    <div class="label-width"
                         v-if="formMap['zone'].indexOf(envConsoleType) > -1">
                        <span>{{$t('分区/数据中心')}}：</span>
                        <span>{{data.zoneName || data.zone}}</span>
                    </div>
                    <!--Openstac IP -->
                    <div class="label-width"
                         v-if="formMap['openIp'].indexOf(envConsoleType) > -1">
                        <span>{{$t('IP地址')}}：</span>
                        <span>{{(data.publicIp ? '('+$t('公')+')' + data.publicIp : '') + ' ' + (data.innerIp ? '('+$t('内')+')' + data.innerIp : '')}}</span>
                    </div>
                    <!-- 接入ip地址 -->
                    <div class="joinIp"
                         v-if="(data.publicIp || data.innerIp) && formMap['joinIp'].indexOf(envConsoleType) > -1">
                        <!-- <p>请选择接入IP地址</p> -->
                        <!-- 如果存在公网IP和内网IP值一样的情况-->
                        <div v-if="isEqualJoinIp()"
                             style="margin-top:10px">
                            <div class="customcheck">
                                <ul class="rc-list">
                                    <li class="rc-ellipsis"
                                        v-for="(item, index) in joinIps"
                                        :class="{active: item.active}"
                                        @click="selectIp(item, index)"
                                        :key="index">
                                        <div class="content-right">
                                            <div class="info-top mar-top8">
                                                <span>{{item.name}}：</span>
                                                <span class="ip-span">{{item.ip}}</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <RadioGroup style="width: 100%;margin-left:0px"
                                    v-else
                                    v-model="selectedPublic"
                                    vertical>
                            <!-- bug13174,公有云内网Ip不能链接 -->
                            <div class="webssh"
                                 v-show="cloudComputeMap[data.cloudEnvType] !== 'public'"
                                 v-if="data.innerIp">
                                <Radio style="width:max-content;display:inline-block;"
                                       :label="innerIp">
                                    <span></span>
                                </Radio>
                                <div class="webssh-content">
                                    <span>内网IP：</span>
                                    <span class="ip-span"
                                          :title="data.innerIp"
                                          v-if="data.innerIp.split(',').length === 1">{{data.innerIp}}</span>
                                    <Select v-else
                                            v-model="innerIp"
                                            transfer
                                            @click.stop
                                            class="hostIp">
                                        <Option v-for="val in data.innerIp.split(',')"
                                                :key="val"
                                                :value="val">{{val}}</Option>
                                    </Select>
                                </div>
                            </div>
                            <div class="webssh"
                                 v-if="data.publicIp">
                                <Radio style="width:max-content;display:inline-block;"
                                       :label="publicIp">
                                    <span></span>
                                </Radio>
                                <div class="webssh-content">
                                    <span>公网IP：</span>
                                    <span class="ip-span"
                                          :title="data.publicIp"
                                          v-if="data.publicIp.split(',').length === 1">{{data.publicIp}}</span>
                                    <Select v-else
                                            v-model="publicIp"
                                            transfer
                                            class="hostIp">
                                        <Option v-for="val in data.publicIp.split(',')"
                                                :key="val"
                                                :value="val">{{val}}</Option>
                                    </Select>
                                </div>
                            </div>
                        </RadioGroup>
                    </div>
                    <!--用户名 -->
                    <FormItem :label="$t('用户名')+'：'"
                              prop="managementAccount"
                              class="input-c"
                              v-if="formMap['managementAccount'].indexOf(envConsoleType) > -1">
                        <Input style="width: 168px;"
                               v-model="formData.managementAccount" />
                    </FormItem>
                    <!--密码-->
                    <FormItem prop="managemenPassword"
                              class="input-c"
                              :label="formatLabel('managemenPassword')+ '：'"
                              v-if="formMap['managemenPassword'].indexOf(envConsoleType) > -1 && remoteLoginType === 'ByPassword'">
                        <Input style="width: 168px;"
                               :type="`${isPass ? 'text' : 'password'}`"
                               v-model="formData.managemenPassword" />
                        <i class="eye-i"
                           @click="isPass = !isPass"
                           :class="{true:'icon-open-up-o',false:'icon-close-1-o'}[isPass]"></i>
                    </FormItem>
                    <!--aliyun密码 -->
                    <FormItem prop="aliPassword"
                              :label="$t('终端密码')+'：'"
                              v-if="formMap['aliPassword'].indexOf(envConsoleType) > -1">
                        <Input :type="`${isPass ? 'text' : 'password'}`"
                               style="width: 168px;"
                               v-model="formData.aliPassword"></Input>
                        <i class="eye-i"
                           @click="isPass = !isPass"
                           :class="{true:'icon-open-up-o',false:'icon-close-1-o'}[isPass]"></i>
                        <a @click="openResetPasFunc"
                           style="margin-left:15px;">{{$t('重置密码')}}</a>
                        <div class="rc-label-warning">
                            <span class="icon">
                                <i class="icon-prompt-1-o"></i>&nbsp;</span>
                            <span>{{$t('如忘记终端密码，请重置')}}</span>
                        </div>
                    </FormItem>
                    <!--密钥 -->
                    <FormItem :label="formatLabel('keypairId')+ '：'"
                              prop="keypairId"
                              class="input-c"
                              v-if="formMap['keypairId'].indexOf(envConsoleType) > -1 && remoteLoginType === 'ByKeypair'">
                        <Select v-model="formData.keypairId"
                                style="width:168px;margin-left:-15px"
                                :transfer="true">
                            <Option v-for="item in keyPairs"
                                    :value="item.id"
                                    :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                    <!--端口 -->
                    <FormItem prop="sshPort"
                              class="input-c"
                              :label="formatLabel('sshPort')+ '：'"
                              v-if="formMap['sshPort'].indexOf(envConsoleType) > -1">
                        <Poptip trigger="hover"
                                v-if="data.operType && (data.operType.indexOf('RDP') > -1)">
                            <span style="cursor:pointer">
                                <InputNumber style="width:168px"
                                             :max="65535"
                                             :min="0"
                                             v-model.number="formData.sshPort" />
                            </span>
                            <div slot="content">
                                <p style="color:#3498dc">{{$t('常用访问端口')}}3389</p>
                            </div>
                        </Poptip>
                        <div v-else>
                            <InputNumber style="width:168px"
                                         :max="65535"
                                         :min="0"
                                         v-model.number="formData.sshPort" />
                        </div>
                    </FormItem>

                </Form>
            </div>
            <div slot="footer">
                <p style="float:left"
                   v-if="envConsoleType === 'Aliyun'">
                    <span>
                        <i class="env-icon aliyun-icon"></i>
                    </span>&nbsp;阿里云管理终端只允许独享方式访问
                </p>
                <Button @click="cancel"
                        class="ivu-btn-text">取消</Button>
                <Button type="primary"
                        :loading="loading"
                        @click="submit">{{loading ? '连接中' : '确定'}}</Button>
            </div>
        </Modal>
        <aliyunresetpassword ref="aliyunresetpassword"
                             @resetPasword="resetPasword"
                             :cloudID="data.cloudEnvId || ''"
                             :hostID="data.instanceId || ''" />
    </div>
</template>

<script>
import API from '@/service/api.js'
import aliyunresetpassword from './aliyunresetpassword.vue'
export default {
    name: 'remotelinkoper',
    props: ['data', 'type'],
    components: {
        aliyunresetpassword
    },
    data () {
        return {
            keypairId: null,
            cloudComputeMap: {
                Aliyun: 'public',
                Azure: 'public',
                Qcloud: 'public',
                Aws: 'public',
                RightScale: 'public',
                HuaweiCloud: 'public',
                OpenStack: 'private',
                'OpenStack-Admin': 'private',
                Nine9Cloud: 'private',
                'Nine9Cloud-Admin': 'private',
                VMware: 'private',
                ESCloud: 'private',
                'ESCloud-Admin': 'private',
                FusionCompute: 'private'
            },
            modal: false,
            loading: false,
            formMap: {
                instanceId: 'OpenStack,OpenStack-Admin,CloudOS,Nine9Cloud,Nine9Cloud-Admin,VMware,Aliyun,ESCloud,ESCloud-Admin',
                zone: 'OpenStack,OpenStack-Admin,CloudOS,Nine9Cloud,Nine9Cloud-Admin,VMware,Aliyun,ESCloud,ESCloud-Admin',
                keypairId: 'VMware,CloudOS,webSSH,WebRDP',
                joinIp: 'webSSH,WebRDP',
                managementAccount: 'VMware,webSSH,WebRDP',
                managemenPassword: 'VMware,webSSH,WebRDP',
                aliPassword: 'Aliyun',
                sshPort: 'webSSH,WebRDP',
                openIp: 'OpenStack,OpenStack-Admin,Nine9Cloud,Nine9Cloud-Admin,ESCloud,ESCloud-Admin'
            },
            formData: {
                aliPassword: '',
                sshPort: null,
                managemenPassword: '',
                managementAccount: '',
                keypairId: null
            },
            rules: {
                aliPassword: { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                sshPort: { required: true, type: 'number', message: this.$i18n.t('该字段不能为空'), trigger: 'change' },
                managementAccount: { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                managemenPassword: { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                keypairId: { type: 'number', required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' }
            },
            selectedPublic: '',
            selectedInner: '',
            isPass: false,
            innerIp: '',
            publicIp: '',
            remoteParams: {
                ip: null,
                port: null,
                username: null,
                password: null,
                loginType: null,
                keypairId: null
            },
            keyPairs: [],
            joinIps: [],
            envConsoleType: '',
            remoteLoginType: '',
            isShowForm: false,
            osIcon: {
                linux: require('@/assets/images/console/servicedetails/linux.png'),
                windows: require('@/assets/images/console/servicedetails/windows.png'),
                aix: require('@/assets/images/console/servicedetails/aix.png'),
                noneos: require('@/assets/images/console/servicedetails/noneos.png')
            }
        }
    },
    created () {
        this.init()
        if (this.data.innerIp && this.data.innerIp.split(',').length === 1 && this.data.publicIp && this.data.publicIp.split(',').length === 1 && this.data.publicIp === this.data.innerIp) {
            this.joinIps.push({
                name: this.$t('内网IP'),
                ip: this.data.innerIp,
                active: true
            }, {
                name: this.$t('公网IP'),
                ip: this.data.publicIp,
                active: false
            })
        }
    },
    methods: {
        formatLabel (type) {
            switch (type) {
                case 'managemenPassword':
                    return '密' + '\xa0\xa0\xa0' + '码'
                case 'sshPort':
                    return '端' + '\xa0\xa0\xa0' + '口'
                case 'keypairId':
                    return '密' + '\xa0\xa0\xa0' + '钥'
            }
        },
        getPassword () {
            if (this.isPass) {
                if (this.formData.managemenPassword && this.data.remoteLoginType !== 'ByKeypair') {
                    return this.formData.managemenPassword
                } else {
                    if (this.data.remoteLoginType === 'ByKeypair') {
                        return this.data.keypairName
                    } else {
                        return '--'
                    }
                }
            } else {
                return '******'
            }
        },
        // 判断内网ip和外网ip是否一样
        isEqualJoinIp () {
            if (this.data.innerIp && this.data.innerIp.split(',').length === 1 && this.data.publicIp && this.data.publicIp.split(',').length === 1 && this.data.publicIp === this.data.innerIp) {
                return true
            }
            return false
        },
        selectIp (item, index) {
            this.joinIps.forEach((item, index) => {
                item.active = false
                this.$set(this.data, index, item)
            })
            this.$set(item, 'active', true)
        },
        isShowPass (item) {
            if (item.key === 'ByPassword' && this.data.remoteLoginType === 'ByPassword') {
                return true
            }
            return false
        },
        init () {
            // hostName 为自服务实例详情获取的主机名称
            this.data.instanceName = this.data.instanceName ? this.data.instanceName : this.data.hostName
            this.formData.aliPassword = this.data.vncPassword || ''
            this.formData.sshPort = parseFloat(this.data.sshPort).toString() === 'NaN' ? null : parseInt(this.data.sshPort)
            if (this.data.operType && this.data.operType.indexOf('RDP') > -1) {
                // rdp访问的默认端口为3389
                this.formData.sshPort = 3389
            }
            this.formData.managementAccount = this.data.managementAccount || ''
            this.formData.managemenPassword = this.data.managemenPassword || this.data.managementPassword || ''
            // this.formData.keypairId = this.data.keypairId + '' || this.keypairId
            this.formData.keypairId = this.keypairId
            if (this.data.operType) {
                if (this.data.operType.indexOf('RDP') > -1) {
                    this.envConsoleType = 'WebRDP'
                } else if (this.data.operType.indexOf('SSH') > -1) {
                    this.envConsoleType = 'webSSH'
                } else {
                    this.envConsoleType = this.data.cloudEnvType
                }
            }
            this.selectedPublic = this.data.publicIp ? this.data.publicIp.split(',')[0] : (this.data.innerIp ? this.data.innerIp.split(',')[0] : '')
            // 初始化Ip
            this.innerIp = this.data.innerIp ? this.data.innerIp.split(',')[0] : ''
            this.publicIp = this.data.publicIp ? this.data.publicIp.split(',')[0] : ''
            // 登录方式为空的情况
            this.remoteLoginType = !this.data.remoteLoginType ? 'ByPassword' : this.data.remoteLoginType
            this.data.remoteLoginType = !this.data.remoteLoginType ? 'ByPassword' : this.data.remoteLoginType
        },
        openModal () {
            this.isShowForm = false
            this.modal = true
            this.loading = false

            // 获取密码
            this.axios.get(this.urlFormat(API.GET_HOSTS_ACCOUNT, true, [this.data.id])).then(res => {
                this.data.managemenPassword = res.managemenPassword ? this.$decrypt(res.managemenPassword) : ''
                this.init()
                this.isPass = false
                if (this.data.remoteLoginType && this.data.remoteLoginType.toLowerCase() === 'bykeypair') {
                    // 获取密钥下拉列表信息
                    this.axios.get(this.urlFormat(API.GET_ENV_KEYPAIRS, false)).then(result => {
                        this.keyPairs = result
                    })
                }
                // this.saveResActionLog()
                this.keypairId = res.keypairId
                this.formData.keypairId = res.keypairId
                this.isShowForm = true
            })
        },
        getOpType () {
            let opType
            if (this.data.cloudEnvType === 'VMware' && this.data.operType.indexOf('Remote') > -1) {
                opType = 'VMRC'
            } else if (this.data.cloudEnvType === 'VMware' && this.data.operType.indexOf('VMware Web') > -1) {
                opType = 'VM Web'
            } else if (this.data.operType.indexOf('RDP') > -1) {
                opType = 'RDP'
            } else if (this.data.operType.indexOf('SSH') > -1) {
                opType = 'SSH'
            } else {
                opType = 'VNC'
            }
            return opType
        },
        saveResActionLog () {
            const opType = this.getOpType()
            const result = {
                resType: '实例',
                resSid: this.data.id,
                resName: this.data.instanceName,
                opType: `${opType}登录`,
                status: true
            }
            this.axios.post(this.urlFormat(API.GET_ACTION_LOG, true), result).then(res => {

            })
        },
        submit () {
            if (['OpenStack', 'OpenStack-Admin', 'CloudOS', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin'].includes(this.envConsoleType)) {
                this.loading = true
                this.submitData()
                return
            }
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    this.submitData()
                }
            })
        },
        submitData () {
            // bug17272排除华为云
            if (this.data.cloudEnvType === 'HuaweiCloud') {
                if ((this.data.innerIp && this.data.innerIp.split(',').length > 1) || (this.data.publicIp && this.data.publicIp.split(',').length > 1)) {
                    this.selectedPublic = this.innerIp ? this.innerIp : this.publicIp
                }
            }
            let newPage = null
            let remoteType
            if (this.data.operType && (this.data.operType.indexOf('终端') > -1 || (this.envConsoleType === 'VMware' && this.data.operType.toLowerCase().indexOf('vmware web') > -1) || this.data.operType.indexOf('Remote') > -1)) {
                remoteType = this.envConsoleType
            } else if (this.data.operType && this.data.operType.toLowerCase().indexOf('webssh') > -1) {
                remoteType = 'webSSH'
            } else {
                remoteType = this.data.osCategory && this.data.osCategory.toLowerCase() === 'windows' ? 'rdp' : this.envConsoleType
            }
            switch (remoteType) {
                case 'webSSH':
                    if (this.selectedPublic === '') {
                        this.$Notice.error({
                            title: '请选择ip!',
                            desc: ''
                        })
                        this.loading = false
                        break
                    } else {
                        this.$refs.form.validate(v => {
                            if (v) {
                                this.remoteParams.ip = this.selectedPublic
                                this.remoteParams.port = this.formData.sshPort
                                this.remoteParams.username = this.formData.managementAccount
                                this.remoteParams.loginType = !this.data.remoteLoginType ? 'ByPassword' : this.data.remoteLoginType
                                this.remoteParams.osCategory = this.data.osCategory
                                if (this.data.remoteLoginType === 'ByPassword') {
                                    if (this.envConsoleType === 'Aliyun') {
                                        this.remoteParams.password = encodeURIComponent(this.formData.aliPassword)
                                    } else {
                                        this.remoteParams.password = encodeURIComponent(this.formData.managemenPassword)
                                    }
                                } else {
                                    this.remoteParams.keypairId = this.formData.keypairId
                                }
                                // 获取远程连接token
                                this.axios.get(this.urlFormat(API.GET_HOSTS_REMOTE_TOKEN, false), {
                                    params: this.remoteParams
                                }, { timeout: 60000 }).then(res => {
                                    if (res && res.code === 200 && !res.status) {
                                        this.loading = false
                                        return
                                    }
                                    const opType = this.getOpType()
                                    this.$store.commit('setSSHToken', res)
                                    const routeData = this.$router.resolve({
                                        path: '/webssh',
                                        query: {
                                            name: this.data.instanceName,
                                            id: this.data.id,
                                            opType: opType,
                                            resType: '实例'
                                        }
                                    })
                                    window.open(routeData.href, '_blank')
                                    this.modal = false
                                    this.loading = false
                                }).catch(e => {
                                    this.loading = false
                                })
                            } else {
                                this.loading = false
                            }
                        })
                    }
                    break
                case 'Aliyun':
                    this.$refs.form.validate(v => {
                        if (v) {
                            this.axios.get(this.urlFormat(API.GET_HOSTS_CONSOLE, false, [this.data.id])).then(res => {
                                if (res && typeof res !== 'object') {
                                    var datas = '/static/html/host-aliyun-console.html?vncUrl=' + decodeURIComponent(res) + '&instanceId=' + this.data.instanceId + '&isWindows=true' + '&password=' + this.data.vncPassword + '&name=' + encodeURIComponent(this.data.instanceName)
                                    newPage = window.open()
                                    newPage.location.href = datas
                                    this.modal = false
                                } else {
                                    this.$Notice.error({
                                        title: '请求发生错误!',
                                        desc: ''
                                    })
                                }
                                this.loading = false
                            }).catch(e => {
                                this.loading = false
                            })
                        } else {
                            this.loading = false
                        }
                    })
                    break
                case 'ESCloud':
                case 'ESCloud-Admin':
                case 'OpenStack':
                case 'OpenStack-Admin':
                case 'CloudOS':
                case 'Nine9Cloud':
                case 'Nine9Cloud-Admin':
                    this.axios.get(this.urlFormat(API.GET_HOSTS_CONSOLE, false, [this.data.id])).then(res => {
                        if (res && typeof res !== 'object') {
                            // var datas = '/static/html/host-vnc-console-1.html?url=' + decodeURIComponent(res) + '&name=' + encodeURIComponent(encodeURIComponent(this.data.instanceName))
                            var datas = decodeURIComponent(res) + '&name=' + encodeURIComponent(encodeURIComponent(this.data.instanceName))
                            newPage = window.open()
                            newPage.location.href = datas
                            this.modal = false
                        } else {
                            this.$Notice.error({
                                title: '请求发生错误!',
                                desc: ''
                            })
                        }
                        this.loading = false
                    }).catch(e => {
                        this.loading = false
                    })
                    break
                case 'VMware':
                    this.axios.get(this.urlFormat(API.GET_HOSTS_CONSOLE, false, [this.data.id])).then(res => {
                        if (typeof res !== 'object' && res) {
                            var datas = null
                            if (this.data.operType.toLowerCase().indexOf('web') > -1) {
                                datas = '/static/html/host-vmware-console.html?url=' + encodeURIComponent(res) + '&name=' + encodeURIComponent(encodeURIComponent(this.data.instanceName)) + '&osCategory=' + encodeURIComponent(this.data.osCategory)
                            } else {
                                var strings = res.split('&')
                                var hostIp = strings[0].split('/')[2].split(':')[0]
                                var ticket = ''
                                var vmid = ''
                                for (var t = 0; t < strings.length; t++) {
                                    var ar = strings[t].split('vmId=')
                                    if (ar.length > 1) {
                                        vmid = ar[1]
                                    }
                                    var ar2 = strings[t].split('sessionTicket=')
                                    if (ar2.length > 1) {
                                        ticket = ar2[1]
                                    }
                                }
                                datas = 'vmrc://clone:' + ticket + '@' + hostIp + '/?moid=' + vmid
                            }
                            newPage = window.open(datas)
                            // newPage.location.href = datas
                            this.modal = false
                        } else {
                            this.$Notice.error({
                                title: '请求发生错误!',
                                desc: ''
                            })
                        }
                        this.loading = false
                    }).catch(e => {
                        this.loading = false
                    })
                    break
                case 'rdp':
                    this.remoteParams.ip = this.selectedPublic
                    this.remoteParams.port = this.formData.sshPort
                    this.remoteParams.username = this.formData.managementAccount
                    this.remoteParams.loginType = !this.data.remoteLoginType ? 'ByPassword' : this.data.remoteLoginType
                    this.remoteParams.osCategory = this.data.osCategory
                    if (this.data.remoteLoginType === 'ByPassword') {
                        this.remoteParams.password = encodeURIComponent(this.formData.managemenPassword)
                    } else {
                        this.remoteParams.keypairId = this.formData.keypairId
                    }
                    // 获取远程连接token
                    this.axios.get(this.urlFormat(API.GET_HOSTS_REMOTE_TOKEN, false), {
                        params: this.remoteParams
                    }).then(res => {
                        if (res && res.code === 200 && !res.status) {
                            this.loading = false
                            return
                        }
                        // 获取访问服务器地址
                        const restUrl = this.$store.state.app.url.RestUrl
                        const datas = '/static/html/guacd.html?token=' + encodeURIComponent(res) + '&rest=' + encodeURIComponent(restUrl) + '&name=' + encodeURIComponent(encodeURIComponent(this.data.instanceName)) + '&osCategory=' + encodeURIComponent(this.data.osCategory)
                        newPage = window.open()
                        newPage.location.href = datas
                        this.modal = false
                        this.loading = false
                    }).catch(e => {
                        this.loading = false
                    })
                    break
            }
        },
        cancel () {
            this.$refs.form && this.$refs.form.resetFields()
            if (typeof this.formData.sshPort !== 'number') {
                this.formData.sshPort = parseFloat(this.formData.sshPort).toString() === 'NaN' ? null : parseInt(this.formData.sshPort)
            }
            this.modal = false
        },
        openResetPasFunc () {
            this.$refs.aliyunresetpassword.openModal('remote')
        },
        resetPasword (val) {
            this.formData.aliPassword = val
            this.data.vncPassword = val
        },
        download () {
            let url = this.$store.state.app.url.UploadUrl
            if (!url) {
                url = this.$store.state.app.url.RestUrl + '/user-console/static/files'
            }
            window.location.href = url + '/VMware-Remote-Console.zip'
        }
    }
}
</script>

<style lang="less">
.remotelinkoper-modal {
    .ivu-modal-body {
        padding: 0px !important;
    }
    .ivu-modal-close {
        top: 12px;
        right: 20px;
    }
}
</style>

<style lang="less" scoped>
.remotelinkoper-modal {
    .title-container {
        .icon-prompt-1-o {
            position: relative;
            top: 1px;
            color: #3498dc;
            cursor: pointer;
        }
    }
    .os-top {
        margin: 20px 0px;
        text-align: center;
        img {
            width: 60px;
            height: 60px;
        }
    }
    .gradients {
        background: linear-gradient(to left, #efefef, #b6b6b6, #efefef);
        height: 1px;
        margin: 0 auto;
    }
    .eye-i {
        cursor: pointer;
        margin-left: 8px;
    }
    .form {
        overflow: hidden;
        padding-top: 20px;
        padding-left: 0 !important;
        // padding-bottom: 20px;
        .input-c {
            .ivu-input-wrapper {
                margin-left: -15px;
            }
            .ivu-input-number {
                margin-left: -15px;
            }
        }
        .label-width {
            margin-bottom: 15px !important;
            margin-left: 10px !important;
        }
        .formItem {
            float: left;
            padding: 3px;
            width: 50%;
            font-size: 12px;
            color: #000;
            .ivu-input-wrapper {
                width: 180px;
            }
            .eye-i {
                cursor: pointer;
                margin-left: 8px;
            }
            .ivu-form-item-error-tip {
                left: 50px;
            }
        }
        .formItem.all {
            float: left;
            padding: 7px 0px;
            width: 100%;
        }
        .icon-edit {
            cursor: pointer;
        }
    }
    .joinIp {
        display: inline-block;
        width: 100%;
        margin-bottom: 15px;
        margin-left: 10px;
        .webssh {
            width: 47%;
            height: 46px;
            float: left;
            margin: 0px 10px 0px 0px;
            display: flex;
            align-items: center;
            .ivu-radio-group {
                display: block;
            }
            .webssh-content {
                text-indent: 10px;
                display: inline-block;
                width: calc(~'100% - 30px');
                height: 44px;
                border: 1px solid #e9e9e9;
                padding: 6px;
                .ip-span {
                    display: inline-block;
                    height: 32px;
                    line-height: 32px;
                }
                .hostIp {
                    width: 110px;
                    position: relative;
                    bottom: 1px;
                }
            }
        }
        .customcheck {
            .rc-list {
                li {
                    position: relative;
                    display: inline-block;
                    height: 48px;
                    line-height: 48px;
                    width: 180px;
                    // padding: 0 10px;
                    border: 1px solid #e9e9e9;
                    cursor: pointer;
                    margin-right: 10px;
                    .content-right {
                        float: left;
                        margin-top: 6px;
                        .info-top {
                            line-height: 34px;
                            color: #333;
                            margin-left: 15px;
                            width: 115px;
                            word-break: keep-all;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                }
                li:hover {
                    background: #f6f6f6;
                }
                li.active {
                    border: 1px solid #3b97e7;
                }
                li.active:after {
                    content: '';
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    width: 16px;
                    height: 16px;
                    background-image: url(../../../../assets/images/radio-selected.png);
                    background-position: 70.63% 81.08%;
                    background-repeat: no-repeat;
                }
            }
        }
    }
}
@import url('./remotelinkoper.less');
</style>
<style lang="less">
.remotelinkoper-modal {
    .label-width {
        .ivu-form-item-label {
            width: 120px !important;
        }
    }
    .input-c {
        .ivu-form-item-error-tip {
            margin-left: -15px;
        }
    }
}
</style>
